module.exports = __webpack_public_path__ + "static/media/welcomeImage.e0ce27eb.jpg";